import React, { useState } from "react";
import { Link } from "react-router-dom";
import { homepageFaqs } from "../data/faqs";

/* ─── Single Accordion Item ────────────────────────────────────── */
const FAQItem = ({ faq, isOpen, onToggle }) => (
  <div className="overflow-hidden">
    <button
      onClick={onToggle}
      aria-expanded={isOpen}
      className={`w-full flex items-center justify-between px-6 py-4 text-left transition-colors duration-300 ${isOpen
          ? "bg-[#000000] text-white"
          : "bg-[#f5ede4] text-gray-900 hover:bg-[#eee0d0]"
        }`}
    >
      <span className="text-[13px] font-bold uppercase tracking-[0.12em] pr-4 leading-snug">
        {faq.question}
      </span>

      {/* Arrow icon */}
      <span className={`flex-shrink-0 transition-transform duration-300 ${isOpen ? "" : "rotate-180"}`}>
        <svg
          className={`w-5 h-5 ${isOpen ? "text-white" : "text-gray-600"}`}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
        </svg>
      </span>
    </button>

    {/* Answer panel */}
    <div
      className={`overflow-hidden transition-all duration-400 ease-in-out ${isOpen ? "max-h-64 opacity-100" : "max-h-0 opacity-0"
        }`}
    >
      <div className="bg-[#000000]/95 px-6 py-5 border-t border-white/10">
        <p className="font-sans text-[13px] text-gray-300 leading-relaxed">
          {faq.answer}
        </p>
      </div>
    </div>
  </div>
);

/* ─── FAQ Section ──────────────────────────────────────────────── */
const FAQSection = ({ faqs = homepageFaqs, title, subtitle }) => {
  const [openId, setOpenId] = useState(1); // first item open by default

  const toggle = (id) => setOpenId((prev) => (prev === id ? null : id));

  return (
    <section id="faq" className="py-20 bg-white">
      <div className="max-w-[1280px] mx-auto px-4 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">

          {/* ── Left: Section Heading ── */}
          <div className="lg:col-span-4 lg:sticky lg:top-28">
            <p className="font-sans text-[11px] font-bold tracking-[0.25em] text-[#9b1c2e] uppercase mb-4">
              {subtitle || "FAQs"}
            </p>
            <h2 className="text-[32px] sm:text-[38px] font-bold text-gray-900 leading-tight uppercase tracking-wide">
              {title || (
                <>
                  Frequently
                  <br />
                  Asked
                  <br />
                  Questions
                </>
              )}
            </h2>
            <div className="mt-6 w-10 h-0.5 bg-[#9b1c2e]" />
            <p className="font-sans text-sm text-gray-500 leading-relaxed mt-6 max-w-xs">
              Got a question? We've got answers. If you don't find what you're looking for, feel free to{" "}
              <Link to="/contact-us" className="text-[#9b1c2e] hover:underline font-medium">
                contact us
              </Link>
              .
            </p>
          </div>

          {/* ── Right: Accordion ── */}
          <div className="lg:col-span-8 flex flex-col gap-2.5">
            {faqs.map((faq) => (
              <FAQItem
                key={faq.id}
                faq={faq}
                isOpen={openId === faq.id}
                onToggle={() => toggle(faq.id)}
              />
            ))}
          </div>

        </div>
      </div>
    </section>
  );
};

export default FAQSection;

